import { CssBaseline } from "@mui/material";
import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Outlet,
} from "react-router-dom";
import { Routes } from "./routes/Routes";
import ErrorFallback from "./components/common/ErrorBoundary/ErrorFallback";
import { UpdateRequiredGate } from "./components/Native/UpdateRequiredGate";
import { MetaPixelTracker } from "./providers/MetaPixelTracker";

const AppContent = () => {
  // Better Auth uses cookie-based authentication
  // Cookies are automatically sent with each request, no manual token management needed
  return (
    <>
      <CssBaseline />
      <MetaPixelTracker />
      {/* Wraps every route, including sign-in and onboarding: a binary the API
          has disowned must not be able to reach ANY screen, and an unauthed
          user is exactly as affected as a signed-in one. A no-op on web. */}
      <UpdateRequiredGate>
        <Outlet />
      </UpdateRequiredGate>
    </>
  );
};

// Root layout - no AuthUIProvider needed since we use custom login/register pages
const RootLayout = () => {
  return <AppContent />;
};

// Create router with RootLayout wrapper. Exported for the native link
// interceptor (index.tsx), which routes first-party links in-app from outside
// the React tree.
export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    // Data routers swallow render errors into their own default error page
    // ("Unexpected Application Error!") for any route that isn't inside one of
    // our layout-level ErrorBoundaries (e.g. /auth/settings, which sits
    // outside ProtectedLayout). This root errorElement makes our fallback the
    // floor for every route.
    errorElement: <ErrorFallback />,
    children: createRoutesFromElements(Routes),
  },
]);

const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
